import { Table } from '@heroui/react'

import { RowActions } from '@/components/ui/row-actions'
import { translated } from '@/lib/api/common'

import type { OptionSet } from '../types'

export type OptionSetRowAction = 'edit' | 'delete'

interface OptionSetsTableProps {
  optionSets: OptionSet[]
  onAction: (action: OptionSetRowAction, optionSet: OptionSet) => void
  busyIds: string[]
}

export function OptionSetsTable({ optionSets, onAction, busyIds }: OptionSetsTableProps) {
  return (
    <Table>
      <Table.ScrollContainer>
        <Table.Content aria-label="Product options">
          <Table.Header>
            <Table.Column id="name" isRowHeader>
              Option
            </Table.Column>
            <Table.Column id="values">Values</Table.Column>
            <Table.Column id="actions">
              <span className="sr-only">Actions</span>
            </Table.Column>
          </Table.Header>

          <Table.Body>
            {optionSets.map((optionSet) => (
              <Table.Row key={optionSet.id} id={optionSet.id}>
                <Table.Cell>
                  <span className="font-medium">{translated(optionSet.name)}</span>
                </Table.Cell>

                <Table.Cell>
                  <span className="text-muted text-sm">
                    {optionSet.items?.length
                      ? optionSet.items.map((item) => translated(item.name, '—')).join(', ')
                      : 'No values yet'}
                  </span>
                </Table.Cell>

                <Table.Cell>
                  <RowActions
                    label={translated(optionSet.name)}
                    isBusy={busyIds.includes(optionSet.id)}
                    onAction={(id) => onAction(id as OptionSetRowAction, optionSet)}
                    actions={[
                      { id: 'edit', label: 'Edit' },
                      { id: 'delete', label: 'Delete' },
                    ]}
                  />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Content>
      </Table.ScrollContainer>
    </Table>
  )
}
